import { ClassName } from '../../../common/view/class-name.js';
export const bladeContainerClassName = ClassName('cnt');
